import PxoDescargaTableContainer            from '../Table/Pxo/Descarga/PxoDescargaTableContainer'
import PxoProdutividadeTableContainer       from '../Table/Pxo/Produtividade/PxoProdutividadeTableContainer'
import PxoOciosidadeTableContainer          from '../Table/Pxo/Ociosidade/PxoOciosidadeTableContainer'
import { usePxoPage }               from "../../contexts/PxoPageContext"



const PxoContentSection = () => {
    
    const { notFoundTables } = usePxoPage()
    
    return (

        <section className="flex flex-col gap-4">          
            
            <>
                <h2>Granel</h2>

                <div className="flex flex-row gap-4">
                    <PxoProdutividadeTableContainer segment="granel" />
                    <PxoOciosidadeTableContainer    segment="granel" />
                    <PxoDescargaTableContainer      segment="granel" />
                </div>

                <h2>Outros</h2>

                <div className="flex flex-row gap-4">
                    <PxoProdutividadeTableContainer segment="Outros" />
                    <PxoOciosidadeTableContainer    segment="Outros" />
                    <PxoDescargaTableContainer      segment="Outros" />
                </div>
                
            </>
            
        </section>
        
    );

}


export default PxoContentSection